import { asHintId, type Hint } from '@/shared/stores';

import { DASHBOARD_URGENT_TAB_ANCHOR } from '../anchors';

/**
 * Step 1 of the dashboard onboarding sequence. Priority is set well below
 * the patient-workspace hints (80–100) so dashboard coachmarks never preempt
 * workspace ones; descending priorities within the dashboard set produce the
 * intended fire order.
 *
 * Bumped to version 2 when the queue's stat-card grid was replaced by a
 * compact summary line — the urgent affordance now lives on the queue tab.
 */
export const dashboardUrgentTabHint: Hint = {
  id: asHintId('dashboard:urgent-tab'),
  version: 2,
  priority: 70,
  anchor: DASHBOARD_URGENT_TAB_ANCHOR,
  copy: {
    title: 'Urgent — same-day response',
    body: 'Urgent patients should be addressed today. Click this tab to focus your queue on patients with urgent requests.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
